module.exports = __webpack_public_path__ + "static/vp3-screen.55d91fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vp3-screen.png
// module id = 1306
// module chunks = 35783957827783